import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Table from 'components/generics/Table/Table';
import Button from 'components/generics/Button';
import ResultTableRow from './table/ResultTableRow';

import { ImportContext } from 'providers/ImportStatus';
import { useNavigate } from 'react-router-dom';

function Result() {
  const [data, setData] = useState([]);
  const { result, resetImportContext, messageToDisplayInResult } = useContext(ImportContext);
  const navigate = useNavigate();
  const locationRoute = window.location.pathname.split('/')[1];
  const { t } = useTranslation();

  useEffect(() => {
    if (result === null) {
      navigate(`/${locationRoute}/import`);
    }

    return () => {
      resetImportContext();
    };
  }, []);

  useEffect(() => {
    if (typeof messageToDisplayInResult === 'string') {
      const data = [
        { exploitationName: 'N/A', endStatus: 'ERREUR', info: [messageToDisplayInResult] },
      ];
      setData(data);
    } else {
      const data = messageToDisplayInResult?.exploitations.map((m) => {
        return {
          exploitationName: m?.name,
          endStatus: m?.status,
          info: m?.message,
        };
      });
      setData(data);
    }
  }, [messageToDisplayInResult]);

  return (
    <div className="section">
      <div className="main_container">
        <h1 className="title_section">{t('title.importResults')}</h1>
        <Table
          header={["Nom de l'exploitation", 'Statut de fin', 'Message']}
          data={data}
          RowElement={ResultTableRow}
        />
      </div>
      <div className="add_button_container">
        <Button
          text={
            locationRoute === 'cooperative'
              ? "Retourner sur la page d'import et de configuration des mappings"
              : 'Nouvel import'
          }
          onClick={() => {
            resetImportContext();
            navigate(`/${locationRoute}/import`);
          }}
        />
      </div>
    </div>
  );
}

export default Result;
